"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.X = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
/**
 * @description
 * 円枠のないXのグリフアイコン。色は currentColor に従う。
 * ロゴの縦横比が 23.4383 : 24 のため、viewBox を横方向にずらして中央に収めている。
 */
var X = function (props) {
    return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, __assign({}, props, { children: (0, jsx_runtime_1.jsx)("svg", { width: "24", height: "24", viewBox: "-0.28085 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { d: "M13.949 10.1624L22.6744 0H20.6068L13.0305 8.82384L6.97931 0H0L9.15056 13.3432L0 24H2.06777L10.0685 14.6817L16.459 24H23.4383L13.949 10.1624ZM11.1169 13.4608L10.1898 12.1321L2.81281 1.55962H5.98879L11.9421 10.0919L12.8692 11.4206L20.6078 22.5113H17.4318L11.1169 13.4608Z", fill: "currentColor" }) }) })));
};
exports.X = X;
